import { Fragment } from "react";
import { champPath } from "../misc/Static";
import Champ from "../images/Champ";
import MatchArenaRow from "./MatchArenaRow";
import MatchArenaRowTiny from "./MatchArenaRowTiny";

import styles from "./MatchArenaDetails.module.css";

export const MatchArenaDetails = ({ region, order, match, calc, width }) => {
  console.log(order)
  return (
    <div className={styles.winner0}>
      <>
        {order.map((team, i) => (
          <div key={"team" + i} className={styles["team" + i]}>
            <div className={styles["t_" + width]}>
              <div className={styles.t_bans}>{match.bans && <>BANS:</>}</div>
              <div className={styles.t_bans2}>
                {team.map((p, j) => (
                  <Fragment key={j}>
                    {match.bans && match.bans[p] > 0 && (
                      <a
                        href={
                          "https://lolalytics.com/lol/" +
                          champPath(match.bans[p]) +
                          "/build/"
                        }
                      >
                        <Champ type="champ24b" id={match.bans[p]} />
                      </a>
                    )}
                  </Fragment>
                ))}
              </div>
              {width !== "xsmall" && width !== "tiny" && (
                <>
                  <div>TIER</div>
                  <div className={styles.t_items}>ITEMS</div>
                  <div>KDA</div>
                  <div className={styles.t_icons}>
                    <img
                      src="https://cdn5.xdx.gg/icons/score.webp"
                      alt="Damage"
                    />
                  </div>
                  <div className={styles.t_icons}>
                    <img src="https://cdn5.xdx.gg/icons/gold.webp" alt="Gold" />
                  </div>
                </>
              )}
            </div>
            {width === "tiny" &&
              team.map((p, j) => (
                <MatchArenaRowTiny
                  key={"player" + j}
                  match={match}
                  calc={calc}
                  region={region}
                  p={p}
                  width={width}
                />
              ))}
            {width !== "tiny" &&
              team.map((p, j) => (
                <MatchArenaRow
                  key={"player" + j}
                  match={match}
                  calc={calc}
                  region={region}
                  p={p}
                  width={width}
                />
              ))}
          </div>
        ))}
      </>
    </div>
  );
};

export default MatchArenaDetails;
